import React from "react"
import { Body } from "components/Shell/Shell"
import { parseUrlQuery } from "utilities"
import { Spinner } from "components/Loaders/Loaders"
import CrossIcon from "@tecuity/sos-icons/react/cross-heavy"
import {
  GET_ACCESS_ID_CC_PAYMENT_STATUS,
  GET_ACCESS_ID_LOC_PAYMENT_STATUS,
  GET_PAYPAL_PAYMENT_STATUS,
  GET_PAYEEZY_PAYMENT_STATUS
} from "requests"

import { GET_CCP_PAYMENT_STATUS } from "../../requests"
import { GET_WALLETAPI_NON_SAVED_PAYMENT_STATUS } from "../../requests"

export default class PaymentCallback extends React.Component {
  state = {
    error: false,
    errorMessage: null
  }
  componentDidMount = () => {
    const { method } = this.props.match.params

    if (method) {
      this.processByMethod(method)
    }
  }
  toggleError = errorMessage => {
    this.setState({ error: true, errorMessage: errorMessage || null })
  }
  processByMethod = method => {
    switch (method.toLowerCase()) {
      case "accessidcc":
        this.getAccessIDCCPaymentStatus()
        break
      case "accessidloc":
        this.getAccessIDLOCPaymentStatus()
        break 
      case "paypal":
        this.getPaypalPaymentStatus()
        break
      case "payeezy":
        this.getPayeezyPaymentStatus()
        break
      case "ccp":
        this.getCCPPaymentStatus()        
        break;

      case "walletapinonsaved":
        this.getWalletAPINonSavedPaymentStatus()
        break;

      case "walletapisaved":
        this.getWalletAPISavedPaymentStatus()
        break;

      default:
    }
  }

  getWalletAPINonSavedPaymentStatus = () =>
  {
    const { ref } = parseUrlQuery(this.props.location.search);
    if (ref)
          GET_WALLETAPI_NON_SAVED_PAYMENT_STATUS(ref, 
                            (webCartNum) => {
                                this.redirectToReceipt(webCartNum)
                            }, 
                            err => {
                              console.error(err);
                              this.toggleError(err.message)
                            })
  }

  getWalletAPISavedPaymentStatus = () =>
  {
    
    const { ref } = parseUrlQuery(this.props.location.search);
    console.log('getWalletAPISavedPaymentStatus');
    if (ref)
      this.redirectToReceipt(ref);

  }

  getCCPPaymentStatus = () =>
  {
    
    const { token } = parseUrlQuery(this.props.location.search);

    const { status} = parseUrlQuery(this.props.location.search);

    if ((status) && status == 'failure')
    {
      this.toggleError('You payment transaction failed. Pleaese try again soon.');
      return;
    }

    if ((status) && status == 'cancel')
    {
      this.toggleError('You payment transaction was cancelled. Pleaese try again soon.');
      return;
    }

    if ((status) && status == 'duplicate')
    {
      this.toggleError('You payment transaction was duplicate. Pleaese try again soon.');
      return;
    }


    if (!token)
    {
      this.toggleError('You have an invalid token');
      return;
    }
      
    const { ref } = parseUrlQuery(this.props.location.search);
    if (ref)
         
      GET_CCP_PAYMENT_STATUS(ref,token, 
                            (webCartNum) => {
                                this.redirectToReceipt(webCartNum)
                            }, 
                            err => {
                              console.error(err);
                              this.toggleError(err.message)
                            })
  }

  getPayeezyPaymentStatus = () => {
    const payload = parseUrlQuery(this.props.location.search)
    if(payload){
      this.props.history.replace(this.props.location.pathname)
    }
    GET_PAYEEZY_PAYMENT_STATUS(payload.x_invoice_num, payload.x_response_code, payload.x_trans_id || "No Value", (response) => {
      this.redirectToReceipt(response)
    }, err => {
      console.error(err);
      this.toggleError(err.message)
    })
  }
  getAccessIDCCPaymentStatus = () => {
    const { token } = parseUrlQuery(this.props.location.search)
    if(token){
      this.props.history.replace(this.props.location.pathname)
    }
    GET_ACCESS_ID_CC_PAYMENT_STATUS(token, ({SECURETOKENID}) => {
      this.redirectToReceipt(SECURETOKENID)
    }, err => {
      console.error(err);
      this.toggleError(err.message)
    })
  }
  getAccessIDLOCPaymentStatus = () => {
    const { token } = parseUrlQuery(this.props.location.search)
    if(token){
      this.props.history.replace(this.props.location.pathname)
    }
    GET_ACCESS_ID_LOC_PAYMENT_STATUS(token, ({SECURETOKENID}) => {
      this.redirectToReceipt(SECURETOKENID)
    }, err => {
      console.error(err);
      this.toggleError(err.message)
    })
  }
  getPaypalPaymentStatus = () => {
    const { SECURETOKENID } = parseUrlQuery(this.props.location.search)
    if(SECURETOKENID){
      this.props.history.replace(this.props.location.pathname)
    }
    GET_PAYPAL_PAYMENT_STATUS(SECURETOKENID, () => {
      this.redirectToReceipt(SECURETOKENID)
    }, err => {
      console.error(err)
      this.toggleError(err.message)
    })
  }
  handlePaypalPayment = () => {
    const { SECURETOKENID } = parseUrlQuery(this.props.location.search)
    this.redirectToReceipt(SECURETOKENID)
  }
  redirectToReceipt = refNum => {
    this.props.history.replace(`/receipt?ref=${refNum}`)
  }
  render() {
    return (
      <Body className="login-redirector payment-callback">
        {
          this.state.error ?
          <PaymentError>{this.state.errorMessage}</PaymentError>
          :
          <div className="flex-column animated fadeIn delay">
            <Spinner className="page-loader" size='medium' themeColor='secondary' />
            <h1 className='message'>Processing your payment</h1>
          </div>
        }
      </Body>
    )
  }
}

export const PaymentError = ({children, errorCode, errorMessage, errorTitle}) => (
  <div className="flex-column">
    <CrossIcon className="text-danger"/>
    <h1 className='message text-danger'>{errorTitle || 'Something went wrong'}</h1>
    {
      typeof children === 'object' ?
      <div className="text-danger pre-wrap">
        {
          children || "An error has occurred while trying to process your payment."
        }
      </div>
      :
      <p className='text-danger pre-wrap'>
        {
          children || "An error has occurred while trying to process your payment."
        }
      </p>
    }
    {
      (errorCode || errorMessage) &&
      <p className='text-danger'>
        <strong>Code {errorCode}</strong> : {errorMessage}
      </p>
    }
  </div>
)
